export const API_BASE_URL = process.env.REACT_APP_BASE_URL;
export const WEB_SOCKET_BASE_URL = process.env.REACT_APP_WEB_SOCKET_BASE_URL;
export const APP_NUDGE_URL = process.env.REACT_APP_NUDGE_DEV_URL;